import { gql } from "@apollo/client";
export const SearchProfileEntries = gql`
  mutation SearchProfile($request: SearchProfileRequest!) {
    SearchProfile(request: $request) {
      data
      total
    }
  }
`;

export const profileData = gql`
  query Profiles(
    $pageSize: Int
    $pageNumber: Int
    $order: String
    $sort: String
  ) {
    Profiles(
      pageSize: $pageSize
      pageNumber: $pageNumber
      order: $order
      sort: $sort
    ) {
      data
      total
    }
  }
`;

export const CollectionNames = gql`
  mutation QueryProfile($profileQuery: ProfileQuery!) {
    QueryProfile(profileQuery: $profileQuery)
  }
`;

export const CreateProfile = gql`
mutation CreateProfile($profile: profileInput!) {
  CreateProfile(profile: $profile) {
    id
  }
}
`;

export const UpdateProfile = gql`
mutation UpdateProfile($updateProfileId: String, $profile: profileInput!, $forceDisableWithActiveCases: Boolean) {
  UpdateProfile(id: $updateProfileId, profile: $profile, forceDisableWithActiveCases: $forceDisableWithActiveCases) {
    id
  }
}
`;

export const UpdateCollectionConfig = gql`
mutation UpdateCollectionConfig($config: JSON!, $service: String) {
  UpdateCollectionConfig(config: $config, service: $service) 
}
`;
